import styled from 'styled-components';
import { InputElement as DefaultInputElement, PlaceholderElement as DefaultPlaceholderElement } from '../Input';

export const InputElement = styled(DefaultInputElement)`
    padding: 0;
`;

export const ContainerElement = styled.div`
    position: relative;
`;

export const PlaceholderElement = styled(DefaultPlaceholderElement)`
    padding: 0;
`;

export const SizerElement = styled.div`
    position: absolute;
    height: 0;
    visibility: hidden;
    overflow: scroll;
    white-space: pre;
`;
